import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import PageTransition from '@/components/page_transition/Index.vue';
import { NAV_DRAWER } from '@/helpers/constants/app';
import { Mutation } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AppViewerAuthorization from '@/plugins/graphql/queries/v2/app-viewer-authorization.gql';
import NetworkDistributorMixin from '@/helpers/vue_mixins/v2/network_distributor/NetworkDistributorMixin';
import me from '@/plugins/graphql/queries/me.gql';
const opts = { namespace: NAV_DRAWER };
let AppsWrapper = class AppsWrapper extends Mixins(ViewportSizeMixin, NetworkDistributorMixin) {
};
__decorate([
    Prop()
], AppsWrapper.prototype, "appUUID", void 0);
__decorate([
    Mutation('toggleDrawer', opts)
], AppsWrapper.prototype, "toggleDrawer", void 0);
__decorate([
    Mutation('populateAppUUID')
], AppsWrapper.prototype, "populateAppUUID", void 0);
__decorate([
    Mutation('populateAppName')
], AppsWrapper.prototype, "populateAppName", void 0);
__decorate([
    Mutation('populateProductComponentUUID')
], AppsWrapper.prototype, "populateProductComponentUUID", void 0);
__decorate([
    Mutation('populateResellerUUID')
], AppsWrapper.prototype, "populateResellerUUID", void 0);
AppsWrapper = __decorate([
    Component({
        apollo: {
            app: {
                query: AppViewerAuthorization,
                variables() {
                    return { appUuid: this.appUUID };
                },
                result({ data }) {
                    /**
                     * Check user privilege to navigate the app
                     * If user has not eligible to visit the app redirect to 404 page
                     * @author Peter John Alvarado <peterjohn@gorated.ph>
                     * @since Version {0.17.0}
                     */
                    const { app } = data;
                    const self = this;
                    if (app && app.viewerAuthorized) {
                        self.populateProductComponentUUID(app.productComponent?.uuid);
                        self.populateAppUUID(self.appUUID);
                        self.populateAppName(app.name);
                        if (this.$store.state.session.token && this.isNetworkDistributor) {
                            this.$apollo
                                .query({
                                query: me,
                            })
                                .then((meQuery) => {
                                const profile = meQuery.data.me;
                                self.populateResellerUUID(profile.uuid);
                            });
                        }
                        self.toggleDrawer(self.mdAndUp);
                    }
                    else {
                        self.$router.push({ name: 'not-found' });
                    }
                },
            },
        },
        components: {
            PageTransition,
        },
    })
], AppsWrapper);
export default AppsWrapper;
